import * as React from 'react';

import { Route } from 'react-router-dom';

const NoAccess = React.lazy(() => import('NoAccess/NoAccess'));

const With404Route: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Route render={({ history }) => ((history.location?.state as { is404: boolean })?.is404 ? <NoAccess /> : children)} />
);

export default With404Route;
